"use client";
import React, {
  useActionState,
  useEffect,
  useTransition,
  useState,
  use,
} from "react";
import { Header } from "@/components/header/header";
import {
  getDefaultAddressAction,
  getCustomerDetailsAction,
  deleteSessionAction,
} from "@/app/actions";
import { ClientWrapperProps } from "@/dto/clientWrapper";

export const HeaderClientWrapper = ({
  merchant,
  menu,
  retailCategories,
  serviceCategories,
  pickupTimePromise,
  paymentConfigPromise,
  preferencesPromise,
}: ClientWrapperProps) => {
  const [isTransitioning, startTransition] = useTransition();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [
    defaultAddressState,
    getDefaultAddressClientAction,
    isDefaultAddressLoading,
  ] = useActionState(getDefaultAddressAction, { data: null, error: null });

  const [
    customerDetailsState,
    getCustomerDetailsClientAction,
    isCustomerDetailsLoading,
  ] = useActionState(getCustomerDetailsAction, { data: null, error: null });

  const [redirectToGiftCard, setRedirectToGiftCard] = useState<boolean>(false);

  useEffect(() => {
    if (merchant.id) {
      startTransition(() => {
        setRedirectToGiftCard(
          !merchant.isPreview && merchant.isStandaloneGiftCardWebsite
        );
        getDefaultAddressClientAction();
        getCustomerDetailsClientAction({ mid: merchant.id });
      });
    }
  }, []);

  const loadingState =
    isDefaultAddressLoading || isCustomerDetailsLoading || isTransitioning;
  useEffect(() => {
    setIsLoading(loadingState);
  }, [loadingState]);

  const defaultAddress = defaultAddressState.data;
  const customerDetails = customerDetailsState.data;

  const merchantPaymentConfig =
    paymentConfigPromise && use(paymentConfigPromise);

  const merchantPreferences = preferencesPromise
    ? use(preferencesPromise)
    : null;

  return (
    <Header
      merchant={merchant}
      merchantName={merchant?.name}
      merchantLogo={merchant?.logo}
      menu={menu}
      redirectToGiftCard={redirectToGiftCard}
      merchantPaymentConfig={merchantPaymentConfig}
      merchantPreferences={merchantPreferences}
      pickupTimePromise={pickupTimePromise}
      defaultAddress={defaultAddress}
      customerDetails={customerDetails}
      retailCategories={retailCategories}
      serviceCategories={serviceCategories}
      deleteSession={deleteSessionAction}
      isLoading={isLoading}
    />
  );
};
